<!-- HTML Template -->
<template>
  <div v-if="is_open">
    <div class="confirmation-popup-overlay">
      <div class="confirmation-popup">
        <h5>{{ getTitle }}</h5>
        <p class="text-secondary">{{ getDescription }}</p>

        <div class="confirmation-popup__buttons-container">
          <button class="ml-auto button button-m button-secondary mr-16" @click="closeModal()">{{ $t('common.cancel') }}</button>
          <button class="button button-m button-primary" @click="confirm()">{{ getButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Javascript -->
<script>
  export default {
    props: {
      title: String,
      description: String,
      button_text: String
    },
    data() {
        return {
          is_open: false,
          data: {},
          display_title: '',
          display_description: '',
          display_button_text: '',
        }
    },
    computed: {

    },
    mounted() {
        console.log('Component mounted.')
    },
    created() {

    },
    methods: {
      setTitle(title) {
        this.display_title = title;
      },
      setDescription(description) {
        this.display_description = description;
      },
      // setButtonText(button_text) {
      //   this.display_button_text = button_text;
      // },
      showConfirm(data) {
        this.data = data;
        this.is_open = true;
      },
      closeModal() {
        this.is_open = false;
        this.data = {};
      },
      confirm() {
        this.$emit('confirmed', this.data);
        this.closeModal();
      }
    },
    computed: {
      getButtonText() {
        return this.button_text || this.display_button_text;
      },
      getTitle() {
        return this.title || this.display_title;
      },
      getDescription() {
        return this.description || this.display_description;
      }
    }
  }
</script>
